import { TaskModel } from "./TaskModel";
import { TaskPersonModel } from "./TaskPersonModel";
import { TaskPriorityModel } from "./TaskPriorityModel";
import { TaskStatusModel } from "./TaskStatusModel";
import { TaskTagModel } from "./TaskTagModel";
import { TaskTypeModel } from "./TaskTypeModel";

/**
 * * Модель сгруппированных задач
 */
export class GroupedTaskItemModel {
  /**Id группы */
  Id?: string | number
  /**Имя группы */
  Name?: string
  /**Статус колонки */
  Status?: TaskStatusModel;
  /**Приоритет в колонке */
  Priority?: TaskPriorityModel;
  /**Исполнитель */
  Performer?: TaskPersonModel;
  /**Автор */
  Author?: TaskPersonModel;
  /**Тег */
  Tag?: TaskTagModel;
  /**Тип задачи */
  Type?: TaskTypeModel;
  /**Кол-во задач в колонке */
  Count!: number;
  /**Элементы в колонке */
  Items!: Array<TaskModel>;

  constructor(obj?: Partial<GroupedTaskItemModel>) {
    Object.assign(this, obj);
  }
}
